import {Component, inject, Signal} from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatButton} from '@angular/material/button'

export interface IWaitDialog {
  title: string,
  text: Signal<string>,
  closable?: boolean,
}

@Component({
  selector: 'aku-wait-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './wait-dialog.html',
  styleUrl: './wait-dialog.scss'
})
export class WaitDialog {
  public data = inject<IWaitDialog>(MAT_DIALOG_DATA)
}
